// Named configuration for the Approvals queues (no SLA literals in the screen).
//
// The business-verification queue carries a server-computed `sla_due_at` and the
// server applies `?sla=due_soon|overdue` (API-133); claims carry `sla_hours` +
// `overdue` (DR-28). What the console still needs locally has no key in the contract's
// settings (PublicSettings / UpdateSettingsBody list no approval or moderation SLA —
// reported as a contract gap in DC92), so the values live here, once:
//
//  - REVIEW_SLA_HOURS — the review target the design shows ("Past the 24 h review SLA")
//    and the service-moderation target FR-A19 says is "held in configuration"; service
//    rows carry only `submitted_at`, so their due time is submitted_at + this.
//  - DUE_SOON_HOURS — the "Due soon (≤12 h)" window of the SLA filter.
export const APPROVAL_SLA = {
  REVIEW_SLA_HOURS: 24,
  DUE_SOON_HOURS: 12,
} as const;
